import { PureComponent } from 'react';
import { getDoc } from '../store/idbHandler';
import { ABHA_CONSENT_URL } from '../api/constants';

export const statusOptions = {
    REQUESTED: {
        text: 'Pending',
        bgColor: 'bg-darwin-accent-bright-yellow-200',
        textColor: 'text-darwin-accent-bright-yellow-900',
        viewAllowed: false,
    },
    DENIED: {
        text: 'Denied',
        bgColor: 'bg-darwin-status-warning-100',
        textColor: 'text-darwin-status-warning-500',
        viewAllowed: false,
    },
    GRANTED: {
        text: 'Success',
        bgColor: 'bg-darwin-accent-green-100',
        textColor: 'text-darwin-accent-green-900',
        viewAllowed: true,
    },
    APPROVAL_ERROR: {
        text: 'Error',
        bgColor: 'bg-darwin-status-warning-100',
        textColor: 'text-darwin-status-warning-500',
        viewAllowed: false,
    },
    ERROR: {
        text: 'Error',
        bgColor: 'bg-darwin-status-warning-100',
        textColor: 'text-darwin-status-warning-500',
        viewAllowed: false,
    },
    EXPIRED: {
        text: 'Expired',
        bgColor: 'bg-darwin-status-warning-100',
        textColor: 'text-darwin-status-warning-500',
        viewAllowed: false,
    },
    InitError: {
        text: 'Error',
        bgColor: 'bg-darwin-status-warning-100',
        textColor: 'text-darwin-status-warning-500',
        viewAllowed: false,
    },
    REVOKED: {
        text: 'Revoked',
        bgColor: 'bg-darwin-status-warning-100',
        textColor: 'text-darwin-status-warning-500',
        viewAllowed: false,
    },
};

type Props = {
    clinicId?: string;
    health_id?: string;
    ptId?: string;
};

export class MedicalRecordsTable extends PureComponent<Props> {
    render() {
        const { clinicId, health_id, ptId } = this.props;

        if (!ptId) {
            return null;
        }

        return (
            <div className="overflow-auto col-span-10 w-full h-full">
                <iframe
                    src={ABHA_CONSENT_URL(ptId, health_id, clinicId)}
                    width="100%"
                    height="100%"
                />
            </div>
        );
    }
}

export default MedicalRecordsTable;
